import { HardHat } from "lucide-react";

export const HelmetGlyph = ({ size = 16, className = "" }) => (
  <HardHat size={size} className={className} aria-label="Helmet" />
);